// Dependencies
import React from "react";

// Material
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

interface LoadingIndicatorProps {
  message?: string;
}

const LoadingIndicator: React.FC<LoadingIndicatorProps> = ({
  message = "Loading...",
}) => (
  <>
    {/* This uses City specific branding */}
    <Box className="preload-spinner-container" data-testid="loading-indicator">
      <div className="preload-spinner"> </div>
      <Typography sx={{ fontWeight: "bold", maxWidth: "none" }}>
        {message}
      </Typography>
    </Box>
  </>
);

export { LoadingIndicator };
